export { default } from './ProductSimilar';



// WEBPACK FOOTER //
// ./src/components/product/ProductSimilar/index.js